import { useQuery } from "@tanstack/react-query";

import { getUnitTimeline } from "@/api/fleet";
import { formatDate } from "@/lib/utils";

interface Props {
  unitId: number;
}

export function HitsTab({ unitId }: Props) {
  const { data, isLoading } = useQuery({
    queryKey: ["unit-timeline", unitId],
    queryFn: () => getUnitTimeline(unitId),
    refetchInterval: 15_000,
  });

  if (isLoading) return <div className="text-muted-200">Cargando…</div>;
  if (!data) return <div className="text-muted-200">Sin hits.</div>;

  return (
    <section className="space-y-2" data-testid="unit-hits">
      <h2 className="text-sm font-semibold">Hits (últimas 24 h)</h2>
      {data.recentHits.length === 0 ? (
        <p className="text-xs text-muted-200">Sin hits recientes.</p>
      ) : (
        <table className="min-w-full text-sm">
          <thead>
            <tr className="text-xs uppercase text-muted-200 border-b border-border">
              <th className="px-2 py-2 text-left">Fecha</th>
              <th className="px-2 py-2 text-left">VIN</th>
              <th className="px-2 py-2 text-left">Placa</th>
              <th className="px-2 py-2 text-left">Fase</th>
            </tr>
          </thead>
          <tbody>
            {data.recentHits.map((h) => (
              <tr key={h.id} className="border-b border-border/40">
                <td className="px-2 py-1.5">{formatDate(h.at)}</td>
                <td className="px-2 py-1.5">{h.vin ?? "—"}</td>
                <td className="px-2 py-1.5">{h.placa ?? "—"}</td>
                <td className="px-2 py-1.5">{h.fase}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  );
}
